import {DrillHoleConfiguration} from "@/Models/DrillHoleConfigurations/DrillHoleConfiguration";

export default class RadialDrillHoleConfiguration implements DrillHoleConfiguration {
	get_input_keys(): string[] {
		return [
			'drillHoleRadialAmount',
			'drillHoleDiameter',
			'drillHoleRadialDiameter',
			'drillHoleRadialOffsetX',
			'drillHoleRadialOffsetY',
		];
	}
}
